import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ProblemSection } from "@/components/ProblemSection";
import { ServiciosSection } from "@/components/ServiciosSection";
import { HowWeWorkSection } from "@/components/HowWeWorkSection";
import { WhyUsSection } from "@/components/WhyUsSection";
import { RubrosSection } from "@/components/RubrosSection";
import { CtaSection } from "@/components/CtaSection";
import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { GoogleLogo } from "@/components/GoogleLogo";
import { GoogleReviewsWidget } from "@/components/GoogleReviewsWidget";
import { testimoniosData } from "@/components/TestimoniosCarousel";
import { useState } from "react";
import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";
import { Play } from "lucide-react";
import { ClientPlyr as Plyr } from "@/components/ClientPlyr";
import { SEOHead } from "@/components/SEOHead";

const EmpresasHero = () => {
  const serviciosMarquee = [
    "ABERTURAS",
    "PILETAS",
    "CLIMATIZACIÓN",
    "REFORMAS",
    "PLOMERÍA",
    "ELECTRICIDAD",
    "PAISAJISMO",
    "SOLAR",
    "CERRAMIENTOS",
    "PINTURA",
    "SEGURIDAD",
    "PORTONES",
    "IMPERMEABILIZACIÓN",
    "TALLERES MECÁNICOS",
  ];

  return (
    <>
      <section className="relative min-h-[90vh] flex items-center pt-32 pb-16 overflow-hidden bg-[#08080A]">
        <div className="absolute inset-0 z-0 flex items-center justify-center pointer-events-none">
          <div className="w-[800px] h-[600px] bg-gradient-to-tr from-[#7C3AED] via-[#6366F1] to-[#FB7185] rounded-full blur-[120px] opacity-20" />
        </div>
        <div
          className="absolute inset-0 z-0 opacity-[0.08] pointer-events-none mix-blend-overlay"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`,
          }}
        />

        <div className="container relative z-20 mx-auto px-6 max-w-[1200px]">
          <div className="max-w-3xl">
            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
              className="text-[34px] sm:text-[44px] lg:text-[56px] font-medium text-[#FAFAFA] tracking-[-0.03em] leading-[1.05] mb-2"
            >
              Más trabajos para empresas de servicios.
            </motion.h1>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{
                duration: 0.6,
                delay: 0.1,
                ease: [0.16, 1, 0.3, 1],
              }}
              className="text-[22px] sm:text-[28px] lg:text-[32px] font-medium tracking-[-0.03em] leading-[1.1] mb-6 bg-gradient-to-r from-[#7C3AED] to-[#FB7185] bg-clip-text text-transparent"
            >
              Sitio web, ficha de Google, reseñas y seguimiento de presupuestos
              — en una semana.
            </motion.p>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{
                duration: 0.6,
                delay: 0.15,
                ease: [0.16, 1, 0.3, 1],
              }}
              className="text-[18px] text-[#A1A1AA] leading-[1.5] mb-8 max-w-2xl"
            >
              El sitio arranca en USD 500. El sistema completo se cotiza en la
              llamada.
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{
                duration: 0.6,
                delay: 0.25,
                ease: [0.16, 1, 0.3, 1],
              }}
              className="flex flex-col sm:flex-row items-center gap-4 w-full sm:w-auto mb-8"
            >
              <button
                onClick={() => {
                  import("@/lib/analytics").then(({ trackCTA }) =>
                    trackCTA("Empresas - Agendar llamada"),
                  );
                  window.location.href = "/demo";
                }}
                className="w-full sm:w-auto bg-[#7C3AED] text-[#FAFAFA] hover:bg-[#7C3AED]/90 hover:-translate-y-[2px] transition-all hover:shadow-[0_12px_32px_rgba(124,58,237,0.25)] font-medium rounded-[12px] px-8 py-[14px] h-auto text-[16px]"
              >
                Agendar una llamada
              </button>
            </motion.div>

            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.35 }}
              className="flex items-center gap-3"
            >
              <GoogleLogo className="w-5 h-5" />
              <div className="flex gap-0.5">
                {[1, 2, 3, 4, 5].map((s) => (
                  <Star
                    key={s}
                    className="w-4 h-4 fill-[#FBBF24] text-[#FBBF24]"
                  />
                ))}
              </div>
              <span className="text-[#A1A1AA] text-[14px]">
                Reseñas en Google
              </span>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Marquesina — solo fila de servicios */}
      <section className="bg-[#08080A] py-12 border-y border-white/10 overflow-hidden relative">
        <div className="relative w-full flex overflow-x-hidden">
          <div className="absolute top-0 left-0 w-32 h-full bg-gradient-to-r from-[#08080A] to-transparent z-10" />
          <div className="absolute top-0 right-0 w-32 h-full bg-gradient-to-l from-[#08080A] to-transparent z-10" />
          <div className="flex whitespace-nowrap animate-[marquee_80s_linear_infinite]">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="flex items-center space-x-10 mx-6">
                {serviciosMarquee.map((item, idx) => (
                  <span
                    key={`${i}-${idx}`}
                    className="text-[#A1A1AA] font-mono text-[13px] tracking-[0.08em] uppercase"
                  >
                    {item}
                    <span className="text-[#71717A] ml-10">·</span>
                  </span>
                ))}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

const EmpresasTestimonios = () => {
  const [activeVideo, setActiveVideo] = useState<string | null>(null);

  // Bass primero, después el caso del corralón completo (Arregui)
  const featured = testimoniosData.filter(
    (t) => t.videoUrl && t.name !== "Facundo Stagnaro",
  );

  return (
    <section
      id="resultados"
      className="bg-[#08080A] py-24 lg:py-[160px] relative scroll-mt-16"
    >
      <div className="container mx-auto px-6 max-w-[1200px]">
        <div className="max-w-3xl mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10%" }}
            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
          >
            <p className="text-[#71717A] font-mono text-[13px] tracking-[0.08em] uppercase mb-6">
              ● LO QUE DICEN LOS CLIENTES
            </p>
            <h2 className="text-[32px] md:text-[44px] lg:text-[56px] font-medium text-[#FAFAFA] tracking-[-0.03em] leading-[1.05] mb-6">
              Negocios reales.
              <br />
              Resultados en los primeros días.
            </h2>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {featured.map((testimonial, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-10%" }}
              transition={{
                duration: 0.6,
                delay: idx * 0.1,
                ease: [0.16, 1, 0.3, 1],
              }}
              className="bg-[#0F0F11] border border-white/5 rounded-[20px] p-8 lg:p-10 flex flex-col justify-between hover:border-white/10 transition-all duration-300 relative overflow-hidden group"
              style={{ boxShadow: "inset 0 1px 0 rgba(255,255,255,0.04)" }}
            >
              <div className="relative z-10 flex flex-col h-full">
                <div className="flex items-center justify-between mb-8">
                  <div className="w-14 h-14 rounded-full bg-[#131316] border border-white/10 flex items-center justify-center">
                    <span className="text-[#FAFAFA] font-medium text-[16px] tracking-wider">
                      {testimonial.initials}
                    </span>
                  </div>
                  <GoogleLogo className="w-6 h-6" />
                </div>

                {testimonial.videoUrl && (
                  <Dialog
                    onOpenChange={(open) => !open && setActiveVideo(null)}
                  >
                    <DialogTrigger asChild>
                      <div
                        className="relative w-full h-48 mb-8 rounded-[12px] overflow-hidden cursor-pointer group/vid border border-white/10 bg-[#08080A] shrink-0"
                        onClick={() => setActiveVideo(testimonial.videoUrl)}
                      >
                        <video
                          src={`${testimonial.videoUrl}#t=0.001`}
                          className="absolute inset-0 w-full h-full object-cover opacity-50 group-hover/vid:opacity-70 transition-opacity duration-300"
                          muted
                          playsInline
                          preload="metadata"
                        />
                        <div className="absolute inset-0 flex items-center justify-center bg-black/40 group-hover/vid:bg-black/20 transition-colors duration-300">
                          <div className="w-14 h-14 rounded-full bg-[#7C3AED]/20 flex items-center justify-center backdrop-blur-md border border-[#7C3AED]/30 group-hover/vid:scale-110 transition-transform duration-300">
                            <Play className="w-6 h-6 text-[#7C3AED] ml-1 fill-current" />
                          </div>
                        </div>
                      </div>
                    </DialogTrigger>
                    <DialogContent className="max-w-4xl bg-black border-white/10 p-0 overflow-hidden">
                      {activeVideo === testimonial.videoUrl && (
                        <div className="relative w-full aspect-video [&_.plyr]:h-full [&_.plyr__video-wrapper]:h-full [&_video]:object-contain bg-black">
                          <Plyr
                            source={{
                              type: "video",
                              sources: [
                                {
                                  src: testimonial.videoUrl,
                                  type: "video/mp4",
                                },
                              ],
                            }}
                            options={{
                              autoplay: true,
                              controls: [
                                "play-large",
                                "play",
                                "progress",
                                "current-time",
                                "mute",
                                "volume",
                                "fullscreen",
                              ],
                            }}
                          />
                        </div>
                      )}
                    </DialogContent>
                  </Dialog>
                )}

                <div className="relative mb-8 flex-grow">
                  <span className="absolute -top-4 -left-4 text-[#7C3AED]/20 text-[60px] font-serif leading-none select-none">
                    &quot;
                  </span>
                  <p className="text-[#FAFAFA] text-[20px] lg:text-[22px] leading-[1.5] relative z-10 font-normal">
                    {testimonial.quote}
                  </p>
                </div>
              </div>

              <div className="relative z-10 mt-auto">
                <div className="mb-6">
                  <p className="text-[#FAFAFA] font-medium text-[16px]">
                    {testimonial.name}
                  </p>
                  <p className="text-[#A1A1AA] text-[14px]">
                    {testimonial.role}
                  </p>
                </div>
                <div className="inline-flex items-center px-3 py-1.5 rounded-[6px] bg-[#34D399]/10 border border-[#34D399]/20">
                  <span className="text-[#34D399] font-mono text-[11px] font-bold tracking-[0.08em] uppercase">
                    {testimonial.metric}
                  </span>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Caso del corralón — franja de dato */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
          className="mt-10 bg-[#0F0F11] border border-[#7C3AED]/20 rounded-[16px] p-8 lg:p-10 text-center"
        >
          <p className="text-[#FAFAFA] text-[18px] lg:text-[22px] leading-[1.5]">
            En un corralón de materiales el sistema completo generó{" "}
            <span className="text-[#7C3AED] font-semibold">
              319 oportunidades y 55 ventas en 20 días.
            </span>{" "}
            Hasta ahí llega esto cuando el negocio tiene volumen.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

const EmpresasDeServicios = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title="Empresas de Servicios — CreceLocal | Sitios web y Sistemas de Marketing"
        description="Más trabajos para empresas de servicios. Te armamos el sitio web, te ordenamos la ficha de Google, te conseguimos las reseñas y hacemos seguimiento de presupuestos. En una semana."
        canonical="/empresas-de-servicios"
      />
      <Navbar />
      <main>
        <EmpresasHero />
        <ProblemSection />
        <GoogleReviewsWidget title="Más reseñas de clientes" />
        <ServiciosSection />
        <RubrosSection />
        <HowWeWorkSection />
        <WhyUsSection />
        <EmpresasTestimonios />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
};

export default EmpresasDeServicios;
